var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.93333V11.7667C12.5 12.496 11.9754 13.124 11.252 13.22C9.8607 13.4047 8.44137 13.5 7.00004 13.5C5.5587 13.5 4.13937 13.4047 2.74804 13.22C2.0247 13.124 1.50004 12.496 1.50004 11.7667V8.93333M12.5 8.93333C12.6583 8.79577 12.785 8.62557 12.8713 8.43442C12.9576 8.24328 13.0015 8.03572 13 7.826V5.304C13 4.58333 12.488 3.96067 11.7754 3.854C11.0202 3.74095 10.2613 3.65489 9.50004 3.596M12.5 8.93333C12.3707 9.04333 12.22 9.13 12.0514 9.18667C10.4222 9.72723 8.71656 10.0019 7.00004 10C5.2347 10 3.5367 9.714 1.9487 9.18667C1.78421 9.13195 1.63185 9.04592 1.50004 8.93333M1.50004 8.93333C1.34173 8.79577 1.21508 8.62557 1.12877 8.43442C1.04246 8.24328 0.998545 8.03572 1.00004 7.826V5.304C1.00004 4.58333 1.51204 3.96067 2.2247 3.854C2.97983 3.74094 3.73876 3.65489 4.50004 3.596M9.50004 3.596V3C9.50004 2.60218 9.342 2.22064 9.0607 1.93934C8.77939 1.65804 8.39786 1.5 8.00004 1.5H6.00004C5.60221 1.5 5.22068 1.65804 4.93938 1.93934C4.65807 2.22064 4.50004 2.60218 4.50004 3V3.596M9.50004 3.596C7.83585 3.46739 6.16422 3.46739 4.50004 3.596M7.00004 8H7.00537V8.00533H7.00004V8Z",
    stroke: "#9499A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpec);
export default __webpack_public_path__ + "static/media/spec.3b24c462214500a98b779d52a376744a.svg";
export { ForwardRef as ReactComponent };